import React, { useEffect } from 'react';

import { animated, useSpring } from 'react-spring';

const REVEAL_SPRING = { friction: 26, tension: 280 };
const SETTLED = { opacity: 1, y: 0 };

/**
 * Fades a newly arrived row up into place. Only opacity and transform animate: the virtualizer
 * measures every row, and a row that changed height as it opened would be measured, re-estimated
 * and laid out again under the reader.
 */
export function ActivityRowReveal({
  arriving,
  children,
  onRevealed,
}: {
  arriving: boolean;
  children: React.ReactNode;
  onRevealed: () => void;
}): JSX.Element {
  const springs = useSpring({
    config: REVEAL_SPRING,
    from: arriving ? { opacity: 0, y: 16 } : SETTLED,
    onRest: () => {
      if (arriving) onRevealed();
    },
    to: SETTLED,
  });

  // A row scrolled out of the window mid-reveal never comes to rest, so it counts as revealed.
  useEffect(() => {
    if (arriving) return onRevealed;
  }, [arriving, onRevealed]);

  return <animated.div style={springs}>{children}</animated.div>;
}
